import { render, staticRenderFns } from "./CreateWalletMnemonicPhrase.vue?vue&type=template&id=4a3ee89f&scoped=true&"
import script from "./CreateWalletMnemonicPhrase.vue?vue&type=script&lang=js&"
export * from "./CreateWalletMnemonicPhrase.vue?vue&type=script&lang=js&"
import style0 from "./CreateWalletMnemonicPhrase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CreateWalletMnemonicPhrase.vue?vue&type=style&index=1&id=4a3ee89f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ee89f",
  null
  
)

export default component.exports